// @todo refactor - rename to `config.js` or `vis-config.js`?
export const DEFAULT_OPTIONS = {
  layout: {
    randomSeed: 1, // toggles a static layout (always the same)
    // clusterThreshold: 150,
  },
  interaction: {
    hover: true,
    tooltipDelay: 999999, // disable hover tool tip on nodes
  },
  nodes: {
    brokenImage: 'no-image.svg',
    margin: 5,
    borderWidth: 2,
    shape: 'dot',
    color: {
      background: 'white',
      border: 'black',
      highlight: { border: 'blue' },
      hover: { border: 'blue' },
    },
    font: {
      color: 'black',
      size: 18,
      strokeWidth: 5,
      strokeColor: 'white',
      vadjust: -45,
    },
    shapeProperties: {
      useBorderWithImage: true, // adds white bg to images
    },
  },
  edges: {
    // width: 1.5, // 2 = too wide when zooming
    arrows: {
      to: { enabled: true, scaleFactor: 0.7 },
      from: { enabled: false, scaleFactor: 0.7 },
    },
    length: 150,
    color: { color: 'black', highlight: 'blue', hover: 'blue' },
    endPointOffset: { to: 2 },
    // physics: true, // edges physics can always stay on (default)
    smooth: { // messes up the physics if it's "straight" (doesn't exist)
      type: 'dynamic',
      roundness: 0,
    },
    // selfReference: {
    //   angle: (40 * Math.PI) / 180,
    // },
  },
  physics: {
    enabled: false,
    stabilization: true, // allows you to see the network re-stabalizing when re-rendering

    // forceAtlas2Based
    // solver: 'forceAtlas2Based',
    // forceAtlas2Based: {
    //   gravitationalConstant: -60,
    // },
    // minVelocity: 5, // stop from spinning

    // barnesHut
    solver: 'barnesHut',
    barnesHut: {
      gravitationalConstant: -40000,
      theta: 0.1,
      springConstant: 0.003,
      damping: 0.13,
    },
    // minVelocity: 0.01, // too low, never stops adjusting
  },
  manipulation: { // needed to expose e.g `addNode()` (for some reason)
    enabled: false, // disable manipulation GUI
    // (some of the events are defined when rendering the network)
  },
};

export default {};
